import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { authGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '', component: LandingComponent
  },
  {
    path: 'user',
    canActivate: [authGuard],
    loadChildren: () => import('./users/users.module')
      .then(m => m.UsersModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
